<template>
  <transition name="a-transition-fade">
    <div v-if="showComment">
      <div :class="['m-edition-asset-comments-item', !isChild ? 'm-edition-asset-comments-item-parent' : '']">
        <span
          v-if="comment.tipo_comentario === 2"
          class="m-edition-asset-comments-item-not-answered"
        >
          {{ $t('mEditionAssetCommentsReplies.messages.notAnswered') }}
        </span>
        <AtomAvatarSecondary :userImage="comment.avatar"/>
        <div class="m-edition-asset-comments-item-info">
          <div class="m-edition-asset-comments-item-info-user">
            <span class="margin-right-xsmall text-color-black-80">
              {{ comment.nombre }}
            </span>
            <span class="font-size-small margin-left-auto text-color-black-35 text-transform-capitalize">
              {{ $moment(comment.fecha_alta).format('D MMM YYYY HH:mm') }}
            </span>
          </div>
          <p>
            <span
              v-html="removeHtml(comment.mensaje)"
              class="text-color-black-60"
            >
            </span>
          </p>
          <div class="m-edition-asset-comments-item-info-actions">
            <a
              class="margin-right-large"
              href="#"
              @click.prevent="toggleCreate"
            >
              <i :class="comentariosTipo === 1 ? 'fas fa-comment text-color-vidroop-primary' : 'fas fa-reply text-color-billing-primary'"></i>
              {{ comentariosTipo === 1 ? $t('mEditionAssetCommentsReplies.tooltip.comment') : $t('mEditionAssetCommentsReplies.tooltip.answer') }}
            </a>
            <a
              class="a-tooltip-primary a-tooltip-bottom margin-right-large"
              :data-tooltip-text="comentariosTipo === 1
              ? comment.children.length
                ? $t('mEditionAssetCommentsReplies.tooltip.seeComments')
                : $t('mEditionAssetCommentsReplies.tooltip.noComments')
              : comment.children.length
                ? $t('mEditionAssetCommentsReplies.tooltip.seeAnswers')
                : $t('mEditionAssetCommentsReplies.tooltip.noAnswers')"
              href="#"
              @click.prevent="toggleChildren"
            >
              <i :class="comentariosTipo === 1 ? 'fas fa-comments text-color-vidroop-primary' : 'fas fa-reply-all text-color-billing-primary'"></i>
                {{ comment.children.length }}
            </a>
            <a
              class="a-tooltip-primary a-tooltip-bottom"
              :data-tooltip-text="$t('mEditionAssetCommentsReplies.tooltip.like')"
              href="#"
              @click.prevent="createContenidoComentarioVoto()"
            >
              <i :class="[isLoadingVote ? 'fas fa-spinner fa-spin' : 'far fa-thumbs-up'
                , comentariosTipo === 1 ? 'text-color-vidroop-primary' : 'text-color-billing-primary']"></i>
                {{ comment.puntaje }}
            </a>
            <a
              class="a-tooltip-primary a-tooltip-bottom margin-left-auto"
              :data-tooltip-text="$t('mEditionAssetCommentsReplies.tooltip.delete')"
              href="#"
              @click.prevent="deleteContenidoComentario"
            >
              <i :class="[isDeletingComment ? 'fas fa-spinner fa-spin' : 'far fa-trash-alt', 'text-color-danger']"></i>
            </a>
          </div>
        </div>
      </div>

      <div class="m-edition-asset-comments-item-child">
        <MoleculeEditionAssetCommentsCreate
          v-if="showCreate"
          :comentarios-tipo="comentariosTipo"
          :comment="comment"
          :contenido="contenido"
          @showReplies="showReplies"
          @toggleCreate="toggleCreate"
        />
        <MoleculeEditionAssetCommentsReplies
          v-show="showChildren && comment.children"
          v-for="child in comment.children"
          :key="child.id"
          :comentarios-tipo="comentariosTipo"
          :comment="child"
          :contenido="contenido"
          :is-child="true"
          @reloadMessage="reloadMessage"
        />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'MoleculeEditionAssetCommentsReplies',

  components: {
    MoleculeEditionAssetCommentsCreate: () => import('@/components/molecules/MoleculeEditionAssetCommentsCreate')
  },

  props: {
    comentariosTipo: Number,
    comment: Object,
    contenido: Object,
    isChild: Boolean
  },

  data () {
    return {
      isDeletingComment: false,
      isLoadingVote: false,
      showChildren: false,
      showComment: true,
      showCreate: false
    }
  },

  methods: {
    createContenidoComentarioVoto (voto) {
      this.isLoadingVote = true
      this.$services.create('contenido', 'createContenidoComentarioVoto', { valor: 1 }, [this.comment.id])
        .then(response => {
          if (this.$route.meta.isEdition === 'asset') {
            this.$modal.updateData()
          } else {
            this.$emit('reloadMessage')
          }
          this.isLoadingVote = false
        })
        .catch(error => {
          console.log(error)
          this.isLoadingVote = false
        })
    },

    deleteContenidoComentario () {
      if (!this.isDeletingComment) {
        this.isDeletingComment = true
        this.$services.delete('contenido', 'deleteContenidoComentario', {}, [this.comment.id])
          .then(response => {
            this.isDeletingComment = false
            this.showComment = false
            if (this.$route.meta.isEdition === 'asset' || !this.isChild) {
              this.$store.commit('unsetAssetSelectedMessageInList')
              this.$modal.updateData()
            } else {
              this.$emit('reloadMessage')
            }
          })
          .catch(error => {
            console.log(error)
          })
      }
    },

    reloadMessage () {
      this.$emit('reloadMessage')
    },

    removeHtml (msg) {
      const regex = /(<([^>]+)>)/ig
      return msg.replace(regex, '')
    },

    showReplies () {
      this.showChildren = true
    },

    toggleChildren () {
      this.showChildren = !this.showChildren
    },

    toggleCreate () {
      this.showCreate = !this.showCreate
    }
  }
}
</script>
